import { PageHeader } from '@/components/ui/PageHeader'
import { useOutletContext } from 'react-router'
import { WorkspacesGrid, WorkspacesGridLoading, WorkspaceStatusTab } from './WorkspacesGrid'
import { WorkspacesTable } from './WorkspacesTable'
import { Suspense, useState } from 'react'
import { DataTableLoading } from '@/catalog-apps/components/component-library/DataTableComponent/DataTableLoading'
import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { WorkspacesOutletContext } from '@/layouts/WorkspacesRootLayout'
import { GridTableToggle } from '@/pages/Applications/ApplicationsHome/GridTableToggle'
import { SearchInput } from '@/catalog-apps/components/component-library/shared/SearchInput'
import { ToggleGroup, ToggleGroupItem } from '@/components/shadcn/toggle-group'
import { useSessionStorage } from '@/hooks'
import { isPlatformAdmin, isSuperUser } from '@/util'

export function WorkspacesHome() {
  const { view, setView } = useOutletContext<WorkspacesOutletContext>()
  const [searchString, setSearchString] = useState<string>('')
  const [activeTab, setActiveTab] = useState<WorkspaceStatusTab>('current')
  const [roles] = useSessionStorage('roles', 0)
  const canToggleArchived = isPlatformAdmin(roles) || isSuperUser(roles)

  return (
    <div className="px-5">
      <PageHeader title="Workspaces" className="px-3">
        {canToggleArchived && (
          <ToggleGroup
            aria-label="Switch between current and archived workspaces"
            className="h-[35px] rounded-md bg-offwhite p-0.5 shadow"
            type="single"
            value={activeTab}
            onValueChange={(value) => {
              if (value) {
                setActiveTab(value as WorkspaceStatusTab)
              }
            }}
          >
            <ToggleGroupItem className="h-[32px] px-2 text-xs font-medium" value="current">
              Active
            </ToggleGroupItem>
            <ToggleGroupItem className="h-[32px] px-2 text-xs font-medium" value="archived">
              Archived
            </ToggleGroupItem>
          </ToggleGroup>
        )}
        <SearchInput value={searchString} onChange={setSearchString} />
        <GridTableToggle value={view} onChange={setView} className="hidden" />
      </PageHeader>
      <QueryErrorBoundary errorMessage="Failed to fetch applications">
        <TablePageContainer>
          {view === 'table' && (
            <Suspense fallback={<DataTableLoading />}>
              <WorkspacesTable searchString={searchString} statusTab={activeTab} />
            </Suspense>
          )}
          {view === 'cards' && (
            <Suspense fallback={<WorkspacesGridLoading />}>
              <WorkspacesGrid searchString={searchString} statusTab={activeTab} />
            </Suspense>
          )}
        </TablePageContainer>
      </QueryErrorBoundary>
    </div>
  )
}
